<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Dépenses",
          icon: "bi bi-cash-coin",
          route: "expenses-index",
        },
        {
          label: "Nouvelle dépense",
          icon: "bi bi-plus-circle-fill",
          route: "expenses-create",
        },
      ],
    };
  },
};
</script>
